import {Component} from '@angular/core';
import {NgIf} from "@angular/common";
import {generate} from "rxjs";
import {AlertService} from "../../../common/alert/alert.service";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {GenerateComponent} from "./generate/generate.component";
import {ReportComponent} from "./report/report.component";
import {LookUpComponent} from "./look-up/look-up.component";

@Component({
    selector: 'promo-codes',
    styleUrls: ['./promo-codes.component.css'],
    templateUrl: './promo-codes.component.html',
    providers: [AlertService],
    imports: [
        NgIf,
        FormsModule,
        ReactiveFormsModule,
        GenerateComponent,
        ReportComponent,
        LookUpComponent,
        ReportComponent,
        LookUpComponent,
    ]
})
export class PromoCodeComponent {
    selectedTab = Tab.Generate

    selectTab(tab: Tab): void {
        this.selectedTab = tab;
    }

    protected readonly Tab = Tab;
    protected readonly generate = generate;
}

export enum Tab {
    Generate, Reports, LookUp
}
